import {
  alertDetailsPageTestIDs,
  alertsModalPageTestIDs,
  currentWeatherConditionsPageTestIDs,
  dailyWeatherPageTestIDs,
  dvrPageTestIDs,
  fullscreenVODPageTestIDs,
  hourlyWeatherPageTestIDs,
  livePageTestIDs,
  loadingPageTestIDs,
  menuTestIDs,
  myWeatherPageTestIDs,
  onboardingTestIDs,
  onDemandPageTestIDs,
  pictureDetailedVODPageTestIDs,
  searchPageTestIDs,
  settingsPageTestIDs,
} from '@constants';
import {
  AlertDetailsPage,
  AlertsModalPage,
  AuthVerificationPage,
  CurrentWeatherConditionsPage,
  DailyWeatherConditionsPage,
  DeviceActivationPage,
  DVRPage,
  ErrorPage,
  FullscreenVODPage,
  HourlyWeatherForecastPage,
  LivePage,
  LoadingPage,
  MyWeatherPage,
  OnboardingFreeTrialPage,
  OnboardingHomePage,
  OnDemandPage,
  PictureDetailedVODPage,
  SearchPage,
  SettingsPage,
  SubscriberSignInPage,
  SubscriberSignUpPage,
  SubscriberWelcomeBackPage,
  SubscriptionSelectionPage,
  SuccessPage,
} from '@screens';

import { DebugItems } from '../../components/debug/DebugItems';
import { DebugMainMenuPage } from '../../components/debug/DebugMainMenuPage';
import { DebugMenuIDs } from '../../components/debug/DebugMenuIDs';

export const initialRoute = livePageTestIDs.livePage;

export const mainMenuScreens = [
  {
    component: LivePage,
    name: livePageTestIDs.livePage,
    options: {
      title: 'Live',
      tabBarAccessibilityLabel: 'Live',
      tabBarTestID: menuTestIDs.live,
    },
  },
  {
    component: MyWeatherPage,
    name: myWeatherPageTestIDs.myWeatherPage,
    options: {
      title: 'My Weather',
      tabBarAccessibilityLabel: 'My Weather',
      tabBarTestID: menuTestIDs.myWeather,
    },
  },
  {
    component: OnDemandPage,
    name: onDemandPageTestIDs.onDemandPage,
    options: {
      title: 'On Demand',
      tabBarAccessibilityLabel: 'On Demand',
      tabBarTestID: menuTestIDs.onDemand,
    },
  },
  {
    component: SettingsPage,
    name: settingsPageTestIDs.settingsPage,
    options: {
      icon: 'settings',
      title: 'Settings',
      tabBarAccessibilityLabel: 'Settings',
      tabBarTestID: menuTestIDs.settings,
    },
  },
];

export const baseScreens = [
  {
    component: LoadingPage,
    name: loadingPageTestIDs.loadingPage,
    options: {
      anfCanOverride: false,
      alertsCanOverride: false,
    },
  },
  {
    component: SearchPage,
    name: searchPageTestIDs.searchPage,
  },
  {
    component: DVRPage,
    name: dvrPageTestIDs.dvrPage,
  },
  {
    component: CurrentWeatherConditionsPage,
    name: currentWeatherConditionsPageTestIDs.currentWeatherConditionsPage,
  },
  {
    component: HourlyWeatherForecastPage,
    name: hourlyWeatherPageTestIDs.hourlyWeatherPage,
  },
  {
    component: DailyWeatherConditionsPage,
    name: dailyWeatherPageTestIDs.dailyWeatherPage,
  },
  {
    component: PictureDetailedVODPage,
    name: pictureDetailedVODPageTestIDs.pictureDetailedVODPage,
  },
  {
    component: FullscreenVODPage,
    name: fullscreenVODPageTestIDs.fullscreenVODPage,
  },
  {
    component: AlertDetailsPage,
    name: alertDetailsPageTestIDs.alertDetailsPage,
    options: {
      presentation: 'transparentModal',
      detachPreviousScreen: false,
      anfCanOverride: true,
      alertsCanOverride: true,
    },
  },
  {
    component: AlertsModalPage,
    name: alertsModalPageTestIDs.alertsModalPage,
    options: {
      presentation: 'transparentModal',
      detachPreviousScreen: false,
      animationEnabled: true,
      anfCanOverride: false,
      alertsCanOverride: false,
    },
  },
];

const debugMenuSubscreens = DebugItems.filter(element => element.component).map(item => ({
  name: item.pageID,
  component: item.component,
}));

export const debugMenuScreens = [
  {
    component: DebugMainMenuPage,
    name: DebugMenuIDs.debugMenuPage,
  },
  ...debugMenuSubscreens,
];

export const onboardingScreens = [
  {
    component: OnboardingHomePage,
    name: onboardingTestIDs.pages.onboardingHomePage,
    options: {
      anfCanOverride: false,
      alertsCanOverride: false,
    },
  },
  {
    component: OnboardingFreeTrialPage,
    name: onboardingTestIDs.pages.onboardingFreeTrialPage,
    options: {
      anfCanOverride: false,
      alertsCanOverride: false,
    },
  },
  {
    component: SubscriberSignUpPage,
    name: onboardingTestIDs.pages.subscriberSignUpPage,
    options: {
      anfCanOverride: false,
      alertsCanOverride: false,
    },
  },
  {
    component: SubscriberSignInPage,
    name: onboardingTestIDs.pages.subscriberSignInPage,
    options: {
      anfCanOverride: false,
      alertsCanOverride: false,
    },
  },
  {
    component: AuthVerificationPage,
    name: onboardingTestIDs.pages.authVerificationPage,
    options: {
      anfCanOverride: false,
      alertsCanOverride: false,
    },
  },
  {
    component: DeviceActivationPage,
    name: onboardingTestIDs.pages.deviceActivationPage,
    options: {
      anfCanOverride: false,
      alertsCanOverride: false,
    },
  },
  {
    component: SubscriptionSelectionPage,
    name: onboardingTestIDs.pages.subscriptionSelectionPage,
    options: {
      anfCanOverride: false,
      alertsCanOverride: false,
    },
  },
  {
    component: SubscriberWelcomeBackPage,
    name: onboardingTestIDs.pages.subscriberWelcomeBackPage,
    options: {
      anfCanOverride: false,
      alertsCanOverride: false,
    },
  },
  {
    component: SuccessPage,
    name: onboardingTestIDs.pages.successPage,
    options: {
      anfCanOverride: false,
      alertsCanOverride: false,
    },
  },
  {
    component: ErrorPage,
    name: onboardingTestIDs.pages.errorPage,
    options: {
      anfCanOverride: false,
      alertsCanOverride: false,
    },
  },
];
